import { render, staticRenderFns } from "./dataInfo.vue?vue&type=template&id=16573eeb&scoped=true&"
import script from "./dataInfo.vue?vue&type=script&lang=js&"
export * from "./dataInfo.vue?vue&type=script&lang=js&"
import style0 from "./dataInfo.vue?vue&type=style&index=0&id=16573eeb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16573eeb",
  null
  
)

export default component.exports